import React from 'react';
// R3F
import { useProgress } from '@react-three/drei'
// MUI Components
import Backdrop from '@material-ui/core/Backdrop';
import Icon from '@material-ui/core/Icon';
// Icons
import loadingIcon from "../../assets/icons/loadingIcon.svg";
import { ReactComponent as MySvg } from '../../assets/icons/ar_logo.svg';
// Helpers
import { sendAnalyticsData } from "../../utility/handleAnalytics";
// Styles
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    defaultBackdrop: {
        zIndex: 1299,
        color: '#2196F3',
        background: 'linear-gradient(45deg, #231f20 0%, #424242 50%, #231f20 100%)'
    },
    debutBackdrop: {
        zIndex: 1299,
        color: '#2196F3',
        background: '#ffffff'
    },
    imageIcon: {
        height: '100%'
    },
    iconRoot: {
        textAlign: 'center',
        height: 112,
        width: 112,
    },
    threeDIcon: {
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%,-50%)',
        width: 30,
        zIndex: 9,
        fill: "#2196F3"
    },
    coverCircle: {
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%,-50%)',
        width: 40,
        height: 40,
        zIndex: 1,
        borderRadius: '50%',
    }
}));

export default function SimpleBackdropLoading(props) {
    const [loadingStatus, setLoadingStatus] = React.useState(true)
    const classes = useStyles();
    const { progress, loaded, total } = useProgress();
    // const { active, progress, errors, item, loaded, total } = useProgress();

    React.useEffect(() => {
        // console.log('>>>', progress, loaded, total, loadingStatus)
        // console.log('>>>', active, progress, errors, item, loaded, total, loadingStatus)
        if(progress === 100 && (loaded > 2 && total > 2) && (loaded === total) && (loadingStatus === true)) {
            const viewerFilesLoaded = async () => {
                try {
                    setLoadingStatus(false);
                    await sendAnalyticsData({ event_type: 'viewer_page_load' });
                } catch (e) {
                    // console.error(e);
                }
            }
            viewerFilesLoaded();         
        }  
    }, [progress, loaded, total, loadingStatus]);

    let classToUse;
    switch(props.params.viewer_type) {
        case 'levar_debut':
        case 'billboard_display':
            classToUse = 'debutBackdrop';
            break;
        default:
            classToUse = 'defaultBackdrop';
    }

    return (
        <Backdrop className={classes[classToUse]} open={true}>
            <Icon classes={{root: classes.iconRoot}}>
                <MySvg className={classes.threeDIcon} />
                <div className={classes.coverCircle}></div>
                <img className={classes.imageIcon} src={loadingIcon} alt="Loading" />
            </Icon>
        </Backdrop>
    );
}
